import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@components/Button/Button'
import useStyles from './styles'
import useCommonStyles from '@screens/OnlineCancellation/commonStyles'
import Page from '@components/Page'
import Header from '@components/Header'
import Footer from '@components/Footer'
import { onPhoneClick } from 'src/utils/onPhoneClick'
import EventBusyIcon from '@mui/icons-material/EventBusy'
import { useIsPhoneOnly } from 'src/config/mediaQueries'

interface TooLateToCancelProps {
  phone?: string
}

export const TooLateToCancel = ({ phone }: TooLateToCancelProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const commonClasses = useCommonStyles()
  const isPhone = useIsPhoneOnly()

  const ctaButton = (
    <Button className={commonClasses.buttonWrapper} text={t('call_clinic')} onClick={() => onPhoneClick(phone)} />
  )

  return (
    <Page
      header={
        <Header desktopHeadingText={t('cancel_appointment_title')} mobileHeadingText={t('cancel_appointment_title')} />
      }
      body={
        <div className={commonClasses.innerWrapper}>
          <div className={commonClasses.contentWrapper}>
            <EventBusyIcon className={classes.icon} />
            <div className={classes.warningText}>{t('too_late_to_cancel_info')}</div>
            {phone && !isPhone && ctaButton}
          </div>
        </div>
      }
      footer={phone && isPhone ? <Footer button={ctaButton} /> : undefined}
    />
  )
}
